import SampleNextArrow from '@/components/SampleNextArrow';
import SamplePrevArrow from '@/components/SamplePrevArrow';
import useIsMobile from '@/hooks/use-is-mobile';
import useAccessoryItem from '@/hooks/WeddingAccessoriesPage/useAccessoryItem';
import Image from 'next/image';
import { useRouter } from 'next/navigation';
import { useCallback } from 'react';
import Slider from 'react-slick';
import Price from '../Price';
import classes from './weddingAccessoriesPage.module.css';

const AccessoryItem = props => {
  const talonProps = useAccessoryItem(props);
  const router = useRouter();

  const { price, images, name, urlKey } = talonProps;
  const isMobile = useIsMobile();

  const sliderProps = {
    dots: false,
    infinite: false,
    showArrows: false,
    slidesToShow: 1,
    arrows: !isMobile,
    nextArrow: isMobile ? null : <SampleNextArrow className={'nextarrow'} />,
    prevArrow: isMobile ? null : <SamplePrevArrow className={'prevarrow'} />,
    slidesToScroll: 1,
  };

  const productImages = images.map((image, index) => {
    return (
      <div
        key={index}
        className={classes.imageContainer}
      >
        <Image
          src={image}
          loading='lazy'
          alt=''
        />
      </div>
    );
  });

  const onClick = useCallback(() => {
    router.push(`/${urlKey}.html`);
  }, [router, urlKey]);

  return (
    <div className={classes.productItem}>
      <Slider {...sliderProps}>{productImages}</Slider>
      <div
        className={classes.productName}
        onClick={onClick}
      >
        {name}
      </div>
      <div className={classes.productPrice}>
        <Price
          value={price.value}
          currencyCode={price.currency}
        />
      </div>
    </div>
  );
};

export default AccessoryItem;
